import React, { useCallback, useEffect, useState } from "react";
import { axios_instance } from "../../../api/axios_instance";
import ShareRemarksModal from "./ShareRemarksModal";
import { useSelector } from "react-redux";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest";
import { format } from "date-fns";

const RemarkPopper = ({
  toggleRemarkPopper,
  isRemarksOpen,
  disbursement_id,
  lead_id,
  user_type,
  fetchHoldCaseRemarksState,
  setFetchHoldCaseRemarksState,
}) => {
  const initialState = { remarksData: [], showDropDownId: -1, newRemark: "" };
  const [remarksState, setRemarksState] = useState(initialState);

  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.user);

  const getSource = (sourceId) => {
    const sources = {
      1: "source: loanbox",
      3: "source: titlebox",
    };
    return sources[sourceId] || "";
  };

  const fetchRemarksData = useCallback(async () => {
    try {
      setIsLoading(true);
      const reqData = encryptRequest({
        disbursement_id,
        lead_id,
      });
      let remarksData = await axios_instance({
        url: "/dts/getRemarksData",
        method: "POST",
        data: { reqData },
      });
      remarksData = decryptRequest(remarksData.data.resData);

      setRemarksState((prevState) => ({
        ...prevState,
        remarksData: remarksData.result,
        newRemark: "",
      }));
      setFetchHoldCaseRemarksState((prevState) => false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [disbursement_id, lead_id, setFetchHoldCaseRemarksState]);

  useEffect(() => {
    fetchRemarksData();
  }, [disbursement_id, fetchRemarksData]);

  useEffect(() => {
    if (fetchHoldCaseRemarksState) fetchRemarksData();
  }, [fetchHoldCaseRemarksState, fetchRemarksData]);

  if (!disbursement_id) return;

  const openShareRemarkModal = (e, id) => {
    setRemarksState({
      ...remarksState,
      showDropDownId: remarksState.showDropDownId !== id ? id : -1,
    });
    e.stopPropagation();
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      try {
        await axios_instance({
          url: "/dts/insertRemarksData",
          method: "POST",
          data: {
            disbursement_id,
            lead_id,
            remarks: remarksState.newRemark,
            user_type: user_type.charAt(0) + user_type.slice(1).toLowerCase(),
            user_id: user.id,
            user_name: user.name,
          },
        });
        fetchRemarksData();
      } catch (error) {}
    }
  };

  return (
    <div className="new-remark-btn">
      {!isRemarksOpen ? (
        <div
          className="fx-remark"
          id="fx-remark-btn"
          onClick={toggleRemarkPopper}
        >
          <span className="mrg-R5">
            <img
              src={`${process.env.REACT_APP_STYLES_PATH}remark-icon.png`}
              alt="icon"
            />
          </span>
          Remarks
          <span id="remarksCount1" className="badge remark-count">
            {isLoading ? (
              <span className="user_heading_3">
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ fontSize: "10px" }}
                ></i>
              </span>
            ) : (
              remarksState?.remarksData?.length
            )}
          </span>
          <span className="minimize remark-tab-btn">
            <img
              src={`${process.env.REACT_APP_STYLES_PATH}minimize.png`}
              alt="icon"
            />
          </span>
        </div>
      ) : (
        <div className="remark-section" id="save-remark-box">
          <div className="panel panel-default">
            <div
              className="panel-heading collapse-remark"
              id="hide-save-remark"
              aria-expanded="true"
              onClick={toggleRemarkPopper}
            >
              <h3 className="panel-title">
                <span className="mrg-R5">
                  <img
                    src={`${process.env.REACT_APP_STYLES_PATH}remark-icon.png`}
                    alt="icon"
                  />
                </span>
                Remarks
                <span id="remarksCount2" className="badge remark-count">
                  {isLoading ? (
                    <span className="user_heading_3">
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ fontSize: "10px" }}
                      ></i>
                    </span>
                  ) : (
                    remarksState?.remarksData?.length
                  )}
                </span>
                <span className="maximize remark-tab-btn">
                  <img
                    src={`${process.env.REACT_APP_STYLES_PATH}minimize.png`}
                    alt="icon"
                  />
                </span>
              </h3>
            </div>
            {!isLoading ? (
              <div className="panel-body">
                <div className="clearfix remark-list">
                  <ul className="" data-mcs-theme="dark" id="remarksBox">
                    {remarksState?.remarksData?.map((val, idx) => {
                      const source = getSource(val.source_id);
                      const makeChDisabled = val.shared_to
                        ? val.shared_to.split(",")
                        : "";
                      let disableLoan =
                          makeChDisabled.length > 1 ||
                          (makeChDisabled.length === 1 &&
                            parseInt(makeChDisabled[0]) === 1)
                            ? true
                            : false,
                        disableTitle =
                          makeChDisabled.length > 1 ||
                          (makeChDisabled.length === 1 &&
                            parseInt(makeChDisabled[0]) === 3)
                            ? true
                            : false;

                      return (
                        <li key={idx}>
                          <div className="remark-msg">
                            {val.remark
                              ? val.remark
                                  .replace(/\\/g, "")
                                  .replace(/<br\s*\/?>/gi, "\n")
                              : ""}
                            {!["1", "3"].includes(val.source_id) && (
                              <div className="dropdown pull-right">
                                <button
                                  className={`dropdown-toggle share-remark-icon ${
                                    remarksState.showDropDownId === val.id
                                      ? "share-button-selected"
                                      : ""
                                  }`}
                                  id={`dropdownMenu_${val.id}`}
                                  onClick={(e) =>
                                    openShareRemarkModal(e, val.id)
                                  }
                                >
                                  {/* <i className="fa fa-share-alt"></i> */}
                                </button>
                                {remarksState.showDropDownId === val.id && (
                                  <ShareRemarksModal
                                    id={val.id}
                                    disableLoan={disableLoan}
                                    disableTitle={disableTitle}
                                    disbursement_id={disbursement_id}
                                    lead_id={lead_id}
                                    closeShareRemarksModal={(e) =>
                                      setRemarksState({
                                        ...remarksState,
                                        showDropDownId: -1,
                                      })
                                    }
                                    fetchRemarksData={fetchRemarksData}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                          <div className="clearfix">
                            <span className="remark-by">
                              by {val.username}{" "}
                              {val.source !== "paymentbox" &&
                                `source ${val.source}`}
                              {/* {val.user_type ? `(${val.user_type})` : ""} */}
                              &nbsp;{source}&nbsp;
                              {format(
                                new Date(val.added_at),
                                "yyyy-MM-dd kk:mm:ss"
                              )}
                            </span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="add-remark-box">
                  <textarea
                    value={remarksState.newRemark}
                    onChange={(e) =>
                      setRemarksState({
                        ...remarksState,
                        newRemark: e.target.value,
                      })
                    }
                    onKeyDown={(e) => handleKeyDown(e)}
                    name=""
                    id="writeRemarks"
                    className="form-control"
                    placeholder="Add a remark"
                  ></textarea>
                </div>
              </div>
            ) : (
              <div
                id="dtsMycase_processing"
                className="dataTables_processing"
                style={{
                  textAlign: "center",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_STYLES_PATH}page-loader.gif`}
                  alt=""
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RemarkPopper;
